import {
  Grid,
  makeStyles,
  Typography,
  CircularProgress,
  Backdrop,
} from "@material-ui/core";
import React, { useState, useEffect, useMemo } from "react";
import { downloadCustomUploadedFile } from "../../../../../../containers/actions/common/fileActions";
import { fetchDSBatchDetails } from "../../../../../../containers/actions/common/saslAction";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { appUrl } from "../../../../../../../../utils/config";
import ShowFiles from "../../../../models/files/ShowFiles";
import GetAppIcon from "@material-ui/icons/GetApp";
import ViewStructuredInformationBox from "./ViewStructuredInformationBox";
import { ReactComponent as StructureIcon } from "../../../../../layout/icons/smc_fill.svg";
import ViewConsumption from "./ViewConsumption";
import UpdateBMRData from "../BMRConsumption/UpdateBMRData";
import CommonDigitizedDocument from "../../../../Digitisation/CommonDigitizedDocument";
import ProductDetailsLoader from "../../ProductDetailsLoader";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Hidden,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  link: {
    color: "blue",
    cursor: "pointer",
    textDecoration: "underline",
    padding: "5px 0px",
  },
  downloadIcon: {
    marginRight: theme.spacing(0.75),
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0.5rem",
    backgroundColor: "#f5f9ff",
    width: "100%",
  },
  closeText: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    cursor: "pointer",
    fontWeight: 500,
    "&:hover": {
      borderBottom: "2px solid red",
    },
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    cursor: "pointer",
    padding: "0.3rem",
  },
  title: {
    fontWeight: 400,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
    },
  },
  main: {
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const StructuredInformation = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  

  
  const {
    structuredFiles,
    downloadFiles,
    batchDetails,
    schrockenDeliveryScheduleID,
    consumption,
    targetQuantity,
    updatedFileName,
    updatedDigitizedName,
    documentCategory,
    digitizedData,
    isDuplicateDigitized,
    poNumber,
    batchNumber,
    cmoBatchNumber,
  } = props;

  const [viewStructuredData, setViewStructuredData] = useState(false);
  const [viewDigitizedDocument, setViewDigitizedDocument] = useState(false);
  const digitizedDocHandleCloseRef = React.useRef(null);
  const handleCloseDigitizedDocument = async () => {
    if (digitizedDocHandleCloseRef.current) {
      digitizedDocHandleCloseRef.current();
    } else {
      setViewDigitizedDocument(false);
      await handleDataRefresh();
    }
  };
  const [parsedKvpData, setParsedKvpData] = useState(null);
  const [kvpParseError, setKvpParseError] = useState(null);
  const [viewStructuredConsumption, setViewStructuredConsumption] = useState(false);
  const [openConsumption, setOpenConsumption] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  const [localBatchData, setLocalBatchData] = useState(batchDetails);

  useEffect(() => {
    if (batchDetails) {
      setLocalBatchData(batchDetails);
    }
  }, [batchDetails]);

  const handleCloseSA = () => {
    setOpenConsumption(false);
  };

  // Parse kvpJson when digitizedData changes
  useEffect(() => {
    if (digitizedData && digitizedData.kvpJson) {
      try {
        setKvpParseError(null);
        const parsed = JSON.parse(digitizedData.kvpJson);
        setParsedKvpData(parsed);
      } catch (error) {
        console.error("Error parsing kvpJson:", error);
        setKvpParseError(error.message);
        setParsedKvpData(digitizedData.originalDigitizedData || null);
      }
    } else {
      setParsedKvpData(null);
      setKvpParseError(null);
    }
  }, [digitizedData]);

  useEffect(() => {
    const extractedDataArray = localBatchData?.digitizedExtractedData;
    if (extractedDataArray && digitizedData) {
      const docType = digitizedData?.documentType;
      const currentFileID = digitizedData?.schrockenCustomFileID;
      
      if (Array.isArray(extractedDataArray)) {
        let matchingDoc = extractedDataArray.find(
          doc => doc.schrockenCustomFileID === currentFileID
        );
        
        if (!matchingDoc && docType) {
          matchingDoc = extractedDataArray.find(
            doc => (doc.kvpJsonOriginal?.document_type === docType || doc.kvpJsonEdited?.document_type === docType)
          );
        }
        
        if (matchingDoc) {
          if (matchingDoc.kvpJsonEdited && Object.keys(matchingDoc.kvpJsonEdited).length > 0) {
            setParsedKvpData(matchingDoc.kvpJsonEdited);
          } else if (matchingDoc.kvpJsonOriginal) {
            setParsedKvpData(matchingDoc.kvpJsonOriginal);
          }
        }
      }
    }
  }, [localBatchData?.digitizedExtractedData, digitizedData]);

  const reviewData = useMemo(() => {
    if (!digitizedData) return null;
    
    const docType = digitizedData?.documentType;
    const currentFileID = digitizedData?.schrockenCustomFileID;
    
    
    let result = null;
    const extractedDataArray = localBatchData?.digitizedExtractedData;

    if (Array.isArray(extractedDataArray)) {
      let matchingDoc = null;
      if (currentFileID) {
        matchingDoc = extractedDataArray.find(
          doc => doc.schrockenCustomFileID === currentFileID
        );
      }
      
      if (!matchingDoc && docType) {
        matchingDoc = extractedDataArray.find(doc => {
          const origDocType = doc.kvpJsonOriginal?.document_type;
          return origDocType && 
            origDocType.replace(/\s+/g, "").toLowerCase() === 
            docType.replace(/\s+/g, "").toLowerCase();
        });
      }

      if (matchingDoc) {
        if (matchingDoc.kvpJsonEdited && 
            Object.keys(matchingDoc.kvpJsonEdited).length > 0 &&
            matchingDoc.kvpJsonEdited.hasOwnProperty('noOfFieldsToBeReviewed')) {
          result = {
            noOfFieldsToBeReviewed: matchingDoc.kvpJsonEdited.noOfFieldsToBeReviewed || 0,
            noOfFieldsReviewed: matchingDoc.kvpJsonEdited.noOfFieldsReviewed || 0,
            markAsReviewed: matchingDoc.kvpJsonEdited.markAsReviewed === true
          };
        } else if (matchingDoc.kvpJsonOriginal) {
          result = {
            noOfFieldsToBeReviewed: matchingDoc.kvpJsonOriginal.noOfFieldsToBeReviewed || 0,
            noOfFieldsReviewed: matchingDoc.kvpJsonOriginal.noOfFieldsReviewed || 0,
            markAsReviewed: false
          };
        }
      }
    } else if (extractedDataArray) {
      const doc = extractedDataArray;
      const matchesById = currentFileID && doc.schrockenCustomFileID === currentFileID;
      const matchesByType = docType && doc.kvpJsonOriginal?.document_type && 
        doc.kvpJsonOriginal.document_type.replace(/\s+/g, "").toLowerCase() === 
        docType.replace(/\s+/g, "").toLowerCase();

      if (matchesById || matchesByType) {
        if (doc.kvpJsonEdited && 
            Object.keys(doc.kvpJsonEdited).length > 0 &&
            doc.kvpJsonEdited.hasOwnProperty('noOfFieldsToBeReviewed')) {
          result = {
            noOfFieldsToBeReviewed: doc.kvpJsonEdited.noOfFieldsToBeReviewed || 0,
            noOfFieldsReviewed: doc.kvpJsonEdited.noOfFieldsReviewed || 0,
            markAsReviewed: doc.kvpJsonEdited.markAsReviewed === true
          };
        } else if (doc.kvpJsonOriginal) {
          result = {
            noOfFieldsToBeReviewed: doc.kvpJsonOriginal.noOfFieldsToBeReviewed || 0,
            noOfFieldsReviewed: doc.kvpJsonOriginal.noOfFieldsReviewed || 0,
            markAsReviewed: false
          };
        }
      }
    }

    return result;
  }, [localBatchData?.digitizedExtractedData, digitizedData]);

  const handleDownloadFile = (schrockenCustomFileID, type) => {
    const data = { schrockenCustomFileID };
    dispatch(downloadCustomUploadedFile(data, type));
  };

  const handleOpenCloseViewStructuredData = () => {
    setViewStructuredData(!viewStructuredData);
  };

  const handleOpenCloseViewDigitizedDocument = () => {
    setViewDigitizedDocument(!viewDigitizedDocument);
  };

  const handleOpenCloseViewStructuredConsumption = () => {
    setViewStructuredConsumption(!viewStructuredConsumption);
  };

  const handleDataRefresh = async () => {
    const batchId = localBatchData?.schrockenDeliveryScheduleBatchID || batchDetails?.schrockenDeliveryScheduleBatchID;
    if (batchId) {
      setIsRefreshing(true);
      try {
        const apiResponse = await axios.post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDeliveryScheduleBatchDetails`,
          { schrockenDeliveryScheduleBatchID: batchId }
        );
        
        if (apiResponse.data.status && apiResponse.data.data) {
        
          
          setLocalBatchData(apiResponse.data.data);
          
          if (props.onRefreshParent) {
            props.onRefreshParent();
          }
        }
      } catch (error) {
        console.error(' StructuredInfo - Error refreshing data:', error);
      } finally {
        setIsRefreshing(false);
      }
    }
  };

  const renderDigitizedComponent = () => {
    if (kvpParseError) {
      return (
        <Box p={3}>
          <Typography variant="h6" color="error">Error Processing Document</Typography>
          <Typography variant="body2" color="error" style={{ marginTop: 16 }}>
            Failed to parse document data: {kvpParseError}
          </Typography>
          {digitizedData?.originalDigitizedData && (
            <>
              <Typography variant="body2" style={{ marginTop: 16 }}>
                Raw document data:
              </Typography>
              <pre style={{ marginTop: 8, padding: 16, backgroundColor: "#f5f5f5", borderRadius: 4, fontSize: "12px" }}>
                {JSON.stringify(digitizedData.originalDigitizedData, null, 2)}
              </pre>
            </>
          )}
        </Box>
      );
    }

    if (!digitizedData) {
      return (
        <Box p={3}>
          <Typography variant="h6">Loading Document...</Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
            Processing digitized document data...
          </Typography>
        </Box>
      );
    }

    const docType = digitizedData?.documentType;

    // Function to get initial data prioritizing kvpJsonEdited over kvpJsonOriginal from digitizedExtractedData
   const getInitialData = () => {
      let selectedData = null;
      const extractedDataArray = localBatchData?.digitizedExtractedData;

      // Handle array structure for digitizedExtractedData
      if (Array.isArray(extractedDataArray)) {
        const matchingDoc = extractedDataArray.find(
          doc => (doc.kvpJsonOriginal?.document_type === docType || doc.kvpJsonEdited?.document_type === docType)
        );

        if (matchingDoc) {
          if (matchingDoc.kvpJsonEdited && Object.keys(matchingDoc.kvpJsonEdited).length > 0) {
            selectedData = JSON.parse(JSON.stringify(matchingDoc.kvpJsonEdited));
          } else if (matchingDoc.kvpJsonOriginal) {
            selectedData = JSON.parse(JSON.stringify(matchingDoc.kvpJsonOriginal));
          }
        }
      } else if (extractedDataArray) {
        // Handle single object structure
        const doc = extractedDataArray;
        if (doc.kvpJsonOriginal?.document_type === docType || doc.kvpJsonEdited?.document_type === docType) {
          if (doc.kvpJsonEdited && Object.keys(doc.kvpJsonEdited).length > 0) {
            selectedData = JSON.parse(JSON.stringify(doc.kvpJsonEdited));
          } else if (doc.kvpJsonOriginal) {
            selectedData = JSON.parse(JSON.stringify(doc.kvpJsonOriginal));
          }
        }
      }

      // No fallback to parsedKvpData to avoid edited data
      return selectedData || {};
    };

    const initialData = getInitialData();

    if (!initialData) {
      return (
        <Box p={3}>
          <Typography variant="h6">No Data Available</Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
            No digitalized data found for this document.
          </Typography>
        </Box>
      );
    }

    // const supportedDocumentTypes = [
    //   "Certificate Of Analysis",
    //   "Certificate Of Manufacture",
    //   "Commercial Invoice",
    //   "Bill Of Lading",
    //   "Packing Slip",
    //   "Consumption Details",
    //   "Delivery Note",
    //   "Packing List",
    //   "Confirmation Of Partial Manufacturing Of An MedicinalProduct",
    //   "Finished Product DispatchCheckList",
    // ];

    // if (!supportedDocumentTypes.includes(docType)) {
    //   return (
    //     <Box p={3}>
    //       <Typography variant="h6">Unsupported Document Type</Typography>
    //       <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
    //         Document type "{docType || 'Unknown'}" is not supported. Raw data:
    //       </Typography>
    //       <pre style={{ marginTop: 16, padding: 16, backgroundColor: "#f5f5f5", borderRadius: 4, fontSize: "12px" }}>
    //         {JSON.stringify(initialData, null, 2)}
    //       </pre>
    //     </Box>
    //   );
    // }
    
    return (
      <CommonDigitizedDocument
        initialData={initialData}
        onClose={async () => {
          setViewDigitizedDocument(false);
          await handleDataRefresh();
        }}
        handleCloseRef={digitizedDocHandleCloseRef}
        schrockenCustomFileID={digitizedData?.schrockenCustomFileID}
        cmoBatchNumber={cmoBatchNumber}
        digitizedData={digitizedData}
        batchDetails={localBatchData}
        poNumber={poNumber}
        batchNumber={batchNumber}
      />
    );
  };

  return (
    <Grid container spacing={3} justifyContent="space-between">
      <Grid item xs={12} sm={6} md={6}>
        <Typography variant="body2" style={{ fontWeight: "bold", paddingTop: "1rem" }}>
          Download Document
        </Typography>
        {downloadFiles.length > 0 ? (
          downloadFiles.map((file, index) => (
            <Grid item xs={12} key={index} style={{ display: "flex", alignItems: "center" }}>
              <GetAppIcon fontSize="small" className={classes.downloadIcon} style={{ color: "blue" }} />
              <Typography
                variant="body2"
                className={classes.link}
                style={{ textDecoration: "underline", fontWeight: 400 }}
                onClick={() => handleDownloadFile(file.schrockenCustomFileID)}
              >
                {updatedFileName}
              </Typography>
            </Grid>
          ))
        ) : (
          <Typography variant="body2">-No Documents Uploaded-</Typography>
        )}
      </Grid>

      {!digitizedData && structuredFiles && !consumption && (batchDetails?.coaJSONEdited || batchDetails?.coaJSONOriginal) ? (
        <Grid item xs={12} sm={6} md={6}>
          <Typography variant="body2" style={{ fontWeight: 500, paddingTop: "1rem" }}>
            Review Digitized Document
          </Typography>
          <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
            <GetAppIcon fontSize="small" style={{ color: "blue" }} />
            <Typography
              variant="body2"
              className={classes.link}
              style={{ textDecoration: "underline" }}
              onClick={() => handleOpenCloseViewStructuredData()}
            >
              {updatedDigitizedName}
            </Typography>
            <StructureIcon style={{ cursor: "pointer" }} onClick={() => handleOpenCloseViewStructuredData()} />
          </Grid>
          {(batchDetails?.coaJSONEdited || batchDetails?.coaJSONOriginal) && (
            <>
              <Typography variant="body2" style={{ color: "#666", marginTop: "0.5rem" }}>
                No. of fields that require review - {(batchDetails?.coaJSONEdited?.noOfFieldsToBeReviewed) || (batchDetails?.coaJSONOriginal?.noOfFieldsToBeReviewed) || 0}
              </Typography>
              <Typography variant="body2" style={{ color: "#666" }}>
                No. of fields reviewed - {(batchDetails?.coaJSONEdited?.noOfFieldsReviewed) || (batchDetails?.coaJSONOriginal?.noOfFieldsReviewed) || 0}
              </Typography>
            </>
          )}
        </Grid>
      ) : null}

      {digitizedData && (
        <Grid item xs={12} sm={6} md={6}>
          <Typography variant="body2" style={{ fontWeight: "bold", paddingTop: "1rem" }}>
            Review Digitalized Document
          </Typography>
          <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
            <GetAppIcon fontSize="small" className={classes.downloadIcon} style={{ color: "blue" }} />
            <Typography
              variant="body2"
              className={classes.link}
              style={{ textDecoration: "underline", color: kvpParseError ? "red" : "blue" }}
              onClick={() => handleOpenCloseViewDigitizedDocument()}
            >
              {kvpParseError ? `${updatedDigitizedName} (Error)` : updatedDigitizedName}
            </Typography>
            <StructureIcon style={{ cursor: "pointer" }} onClick={() => handleOpenCloseViewDigitizedDocument()} />
          </Grid>
          {reviewData && (() => {
            // Check if document category is editable
            const customFile = localBatchData?.customFilesList?.find(
              file => file.schrockenCustomFileID === digitizedData?.schrockenCustomFileID?.toString()
            );
            const category = customFile?.documentCategoryType;
            
            let isCategoryEditable = false;
            if (category === "Post-Manufacturing" && localBatchData?.reviewPostMFGFieldsReqd === true) {
              isCategoryEditable = true;
            } else if (category === "Post-Shipment Documents" && localBatchData?.reviewPostShipmentFieldsReqd === true) {
              isCategoryEditable = true;
            } else if (category === "Pre-Shipment Documents" && localBatchData?.reviewPreShipmentFieldsReqd === true) {
              isCategoryEditable = true;
            }
            
            const textColor = isCategoryEditable ? "#666" : "#999";
            
            return (
              <div key={`review-${digitizedData?.schrockenCustomFileID}-${reviewData.noOfFieldsToBeReviewed}-${reviewData.noOfFieldsReviewed}`}>
                <Typography variant="body2" style={{ color: textColor, marginTop: "0.5rem" }}>
                  No. of fields that require review - {reviewData.noOfFieldsToBeReviewed}
                </Typography>
                <Typography variant="body2" style={{ color: textColor }}>
                  No. of fields reviewed - {reviewData.noOfFieldsReviewed}
                </Typography>
                {(() => {
                  // Find the matching document to check original values
                  const extractedDataArray = localBatchData?.digitizedExtractedData;
                  let originalDoc = null;
                  
                
                  if (Array.isArray(extractedDataArray)) {
                    // Try both string and number comparison to handle type mismatches
                    originalDoc = extractedDataArray.find(
                      doc => doc.schrockenCustomFileID == digitizedData?.schrockenCustomFileID || 
                             String(doc.schrockenCustomFileID) === String(digitizedData?.schrockenCustomFileID)
                    );
                  } else if (extractedDataArray) {
                    originalDoc = extractedDataArray;
                  }
                  
                  
                  // Get the original values
                  const originalReviewed = originalDoc?.kvpJsonOriginal?.noOfFieldsReviewed;
                  const originalToReview = originalDoc?.kvpJsonOriginal?.noOfFieldsToBeReviewed;
                  
                 
                  // Don't show if both original values are 0 (strict comparison)
                  if (originalReviewed === 0 && originalToReview === 0) {
                    return null;
                  }
                  
                  // Only show if there are fields to review or reviewed
                  if (reviewData.noOfFieldsToBeReviewed > 0 || reviewData.noOfFieldsReviewed > 0) {
                    return (
                      <Typography variant="body2" style={{ color: textColor }}>
                        Review marked as complete - {(reviewData.noOfFieldsToBeReviewed === 0 && reviewData.markAsReviewed) ? "Yes" : "No"}
                      </Typography>
                    );
                  }
                  
                  return null;
                })()}
              </div>
            );
          })()}
        </Grid>
      )}

      {consumption && downloadFiles.length > 0 && !digitizedData ? (
        <Grid item xs={12} sm={6} md={6}>
          <Typography variant="body2" style={{ fontWeight: 500, paddingTop: "1rem" }}>
            View digitized document
          </Typography>
          {batchDetails.bomConsumptionAddedIndicator === true && downloadFiles.length > 0 ? (
            <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
              <GetAppIcon fontSize="small" style={{ color: "blue" }} />
              <Typography
                variant="body2"
                className={classes.link}
                style={{ textDecoration: "underline" }}
                onClick={() => setOpenConsumption(true)}
              >
                Consumption_pages
              </Typography>
              <StructureIcon style={{ cursor: "pointer" }} onClick={() => setOpenConsumption(true)} />
            </Grid>
          ) : (
            <Typography variant="body2">NA</Typography>
          )}
        </Grid>
      ) : null}

      {viewStructuredData && (
        <ViewStructuredInformationBox
          coaJSONEdited={batchDetails?.coaJSONEdited}
          batchDetails={batchDetails}
          coaJSONOriginal={batchDetails?.coaJSONOriginal}
          schrockenCustomFileID={structuredFiles?.schrockenCustomFileID ? structuredFiles?.schrockenCustomFileID : null}
          open={viewStructuredData}
          onClose={handleOpenCloseViewStructuredData}
          structuredFiles={structuredFiles}
          documentCategory={documentCategory}
        />
      )}

      {viewDigitizedDocument && (
        <Dialog fullScreen open={viewDigitizedDocument} onClose={handleOpenCloseViewDigitizedDocument}>
          <DialogTitle disableTypography style={{ backgroundColor: "#f5f9ff" }}>
            <Grid container justifyContent="center" className={classes.titleGrid}>
              <Grid item xs={11} sm={11} md={11} className={classes.main}>
                <Typography variant="h4" className={classes.title}>
                  {(documentCategory || "").replace(/\bOf\b/g, 'of')}
                </Typography>
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                <Hidden xsDown implementation="css">
                  <Typography
                    variant="body2"
                    onClick={handleCloseDigitizedDocument}
                    className={classes.closeText}
                  >
                    Cancel <CloseIcon fontSize="large" color="error" className={classes.icon} />
                  </Typography>
                </Hidden>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <Box>{renderDigitizedComponent()}</Box>
          </DialogContent>
        </Dialog>
      )}

      {viewStructuredConsumption && (
        <ViewConsumption
          open={viewStructuredConsumption}
          batchDetails={batchDetails}
          onClose={handleOpenCloseViewStructuredConsumption}
          schrockenDeliveryScheduleID={schrockenDeliveryScheduleID}
          cmoBatchNumber={cmoBatchNumber}
        />
      )}

      {openConsumption && (
        <UpdateBMRData
          {...props}
          schrockenDeliveryScheduleBatchID={batchDetails?.schrockenDeliveryScheduleBatchID}
          schrockenDeliveryScheduleID={batchDetails?.schrockenDeliveryScheduleID}
          bomConsumptionAddedIndicator={true}
          open={openConsumption}
          onClose={handleCloseSA}
          handleClose={handleCloseSA}
          schrockenCustomFileID={downloadFiles.length > 0 ? downloadFiles[0].schrockenCustomFileID : ""}
          batchDetails={batchDetails}
          targetQuantity={targetQuantity}
          viewFlag={true}
        />
      )}

      <Backdrop
        open={isRefreshing}
        style={{ zIndex: 9999, color: '#fff', backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
      >
        <div style={{ textAlign: 'center' }}>
          <CircularProgress color="inherit" size={60} />
          <Typography variant="h6" style={{ marginTop: 16, fontWeight: 500 }}>
            Refreshing data...
          </Typography>
        </div>
      </Backdrop>
    </Grid>
  );
};

export default StructuredInformation;